<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <!-- Left Col -->


    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <app-breadcrumb class="flex-grow-1" />


      <div class="nav">
        <locale
          :locales="langs.locales"
          @updateLocale="changeLocale"
        />
      </div>
      <NotificationDropdown />
      <dark-toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getUserFullname }}
            </p>
            <span class="user-status">{{ getUserRole }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="getUserPhoto"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item> -->

        <!-- <b-dropdown-divider /> -->

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{$t('others.logout')}}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import { localize } from 'vee-validate'
import localeLangs from '@/utils/locales'
import useJwt from '@/auth/jwt/useJwt'
import ru from '@/libs/i18n/vee-validate/ru.json'
import uz from '@/libs/i18n/vee-validate/uz.json'
import { mapActions } from 'vuex'
// import { setLocale } from '@vee-validate/i18n';
import NotificationDropdown from '@/components/NotificationDropdown.vue'



export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    AppBreadcrumb,
    // Navbar Components
    DarkToggler,
    Locale,
    NotificationDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      // user_data: null,
      langs: localeLangs,
    }
  },
  computed: {
    getUserFullname() {
      const {
        first_name,
        username,
      } = useJwt.getUserData()
      const full_name = `${first_name || username}`
      return full_name
    },
    getUserPhoto() {
      const user_data = useJwt.getUserData()
      return user_data?.profile?.photo
    },
    getUserRole() {
      const {
        role_name,
        role,
      } = useJwt.getUserData()
      let roleName = null
      roleName = role.find((elem) => elem == 'admin')
      if(!roleName){
        roleName = role_name[0] ?? 'Пользователь'
      }
      return roleName
    },
  },
  mounted() {
    // if(localStorage.getItem('lang')){
    //   const lang = localStorage.getItem('lang')
    //   localize(lang);
    //   this.$i18n.locale = lang
    // }

    // this.changeLocale()
  },
  methods: {
    ...mapActions('users', ['UPDATE_USER']),
    logout() {
      useJwt.logout()
    },

    async changeLocale() { 
      const { id } = useJwt.getUserData();
      const { locale } = this.$i18n;
      localize(locale);
      localStorage.setItem('lang', locale);
      await this.UPDATE_USER({id: id, language: locale});
      this.$router.go();
    },
  },
}
</script>
